import { IconContent } from '@icons';

export const animalsFilled: IconContent = {
    md: '<path d="M5.036 7.037c-1.13.662-1.462 2.256-.797 3.65a11.591 11.591 0 0 0-2.274 2.906C1.335 14.744 2.287 16 3.6 16h17.15a.75.75 0 0 1 .75.75v.774a.75.75 0 0 1-.873.74l-2.707-.451a8 8 0 0 0-3.845.302l-1.233.41a.5.5 0 1 0 .316.95l1.233-.412a7 7 0 0 1 3.364-.264l2.707.452a1.75 1.75 0 0 0 2.038-1.727v-.774a1.75 1.75 0 0 0-1.59-1.743C21.084 11.848 19.32 7 14.332 7c-2.152 0-4.123.381-5.858 1.057-.867-1.204-2.34-1.665-3.438-1.02Z" />',
};
